import { render, staticRenderFns } from "./Pharmacy.vue?vue&type=template&id=1f4ff344&scoped=true&lang=pug"
import script from "./Pharmacy.vue?vue&type=script&lang=js"
export * from "./Pharmacy.vue?vue&type=script&lang=js"
import style0 from "./Pharmacy.vue?vue&type=style&index=0&id=1f4ff344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ff344",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,DrugNameDesc: require('/home/docker/code/frontend/components/DrugNameDesc.vue').default,DrugAlternatives: require('/home/docker/code/frontend/components/DrugAlternatives.vue').default,ChartBars: require('/home/docker/code/frontend/components/chart/Bars.vue').default})
